import { useTranslation } from "@impero-com/common/utils/i18n";
import { Checkbox } from "antd";

import { PendingActivityTypeFilter } from "./pendingActivityTypeFilter";
import * as theme from "./PendingActivityTypeFilterRow.css";

interface PendingActivityTypeFilterRowProps {
    typeFilter: PendingActivityTypeFilter;
}

export function PendingActivityTypeFilterRow({
    typeFilter,
}: PendingActivityTypeFilterRowProps) {
    const {
        includeControlActivities,
        includeTestingActivities,
        setIncludeControlActivities,
        setIncludeTestingActivities,
    } = typeFilter;
    const { t } = useTranslation();

    return (
        <div className={theme.row}>
            <Checkbox
                checked={includeControlActivities}
                onChange={(e) => setIncludeControlActivities(e.target.checked)}
            >
                {t("Dashboard_PendingActions_IncludeControlActivities")}
            </Checkbox>
            <Checkbox
                checked={includeTestingActivities}
                onChange={(e) => setIncludeTestingActivities(e.target.checked)}
            >
                {t("Dashboard_PendingActions_IncludeTestingActivities")}
            </Checkbox>
        </div>
    );
}
